import {
  Button,
  TextField,
  MenuItem,
  Box,
  DialogActions,
  DialogContent,
  Stack,
  FormControlLabel,
  Switch,
  DialogTitle,
} from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";
import { prettify } from "../../../utils/utils";
import { useNewSmartbox } from "..";

const validationSchema = yup.object({
  description: yup
    .string("Descrizione")
    .required("Il campo non può essere vuoto!"),
  serial_number: yup.string("Numero seriale").required(),
  is_installed: yup.boolean("Installato"),
  is_online: yup.boolean("Online"),
  note: yup.string("Note"),
});

function AddSmartbox({ closeModal }) {
  // === web service queries/mutations ===
  const newSmartboxMutation = useNewSmartbox(closeModal);

  // === Form handling ===
  const formik = useFormik({
    initialValues: {
      description: "",
      is_installed: false,
      is_online: false,
      serial_number: "",
      note: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      newSmartboxMutation.mutate({ ...values });
    },
  });

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <DialogTitle>Nuovo gateway</DialogTitle>
        <DialogContent>
          <Stack direction="row" spacing={8} sx={{ width: "100%" }}>
            <Box sx={{ float: "left", width: "50%" }}>
              <TextField
                autoFocus
                margin="dense"
                fullWidth
                id="description"
                name="description"
                label="Descrizione"
                type="text"
                variant="standard"
                onChange={formik.handleChange}
                value={formik.values.description}
                error={
                  formik.touched.description &&
                  Boolean(formik.errors.description)
                }
                helperText={
                  formik.touched.description && formik.errors.description
                }
              />

              <TextField
                autoFocus
                margin="dense"
                fullWidth
                id="serial_number"
                name="serial_number"
                label="Numero Seriale"
                type="text"
                variant="standard"
                onChange={formik.handleChange}
                value={formik.values.serial_number}
                error={
                  formik.touched.serial_number &&
                  Boolean(formik.errors.serial_number)
                }
                helperText={
                  formik.touched.serial_number && formik.errors.serial_number
                }
              />
            </Box>

            <Box sx={{ float: "right", width: "50%" }}>
              <FormControlLabel
                control={
                  <Switch
                    name="is_installed"
                    value={formik.values.is_installed}
                    checked={formik.values.is_installed}
                    onChange={formik.handleChange}
                  />
                }
                label="Installato"
                labelPlacement="start"
              />
              <FormControlLabel
                control={
                  <Switch
                    name="is_online"
                    value={formik.values.is_online}
                    checked={formik.values.is_online}
                    onChange={formik.handleChange}
                  />
                }
                label="Online"
                labelPlacement="start"
              />

              <TextField
                margin="dense"
                fullWidth
                id="note"
                name="note"
                label="Note"
                multiline
                minRows={4}
                type="text"
                variant="standard"
                onChange={formik.handleChange}
                value={formik.values.note}
              />
            </Box>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button disabled={newSmartboxMutation.isLoading} type="submit">
            Conferma
          </Button>
          <Button
            disabled={newSmartboxMutation.isLoading}
            onClick={formik.handleReset}
          >
            Reset
          </Button>
          <Button
            disabled={newSmartboxMutation.isLoading}
            color="error"
            onClick={closeModal}
          >
            Annulla
          </Button>
        </DialogActions>
      </form>
    </>
  );
}

export default AddSmartbox;
